import axios from 'axios';
import { useEffect, useState } from 'react';
import RichMenuDescription from './RichMenuDescription';
import RichMenuTemplate from './RichMenuTemplate';
import AppConfig from './AppConfig.json'

export default function RichMenuDesigner({ name, data, onSave, line_access_token }) {
    let layouts = [
        { type: 'c', template: [1] },
        { type: 'c', template: [2] },
        { type: 'c', template: [3] },
        { type: 'f', template: [1] },
        { type: 'f', template: [2] },
        { type: 'f', template: [1, 1] },
        { type: 'f', template: [1, 2] },
        { type: 'f', template: [2, 1] },
        { type: 'f', template: [1, 3] },
        { type: 'f', template: [3, 1] },
        { type: 'f', template: [2, 2] },
        { type: 'f', template: [3, 2] },
        { type: 'f', template: [2, 3] },
        { type: 'f', template: [3, 3] },
        { type: 'f', template: [4, 3] },
        { type: 'f', template: [3, 4] },
        { type: 'f', template: [4, 4] },
        { type: 'f', template: [2, 3, 3] },
        { type: 'f', template: [3, 3, 3] },
        { type: 'f', template: [2, 4, 4] },
        { type: 'f', template: [4, 4, 4] },
        { type: 'f', template: [5, 5, 5, 5] }
    ]

    let [selectedLayout, setSelectedLayout] = useState(layouts[0])
    let [selectedImage, setSelectedImage] = useState(null)
    let [previewImage, setPreviewImage] = useState(null)


    let [richmenuObject, setRichmenuObject] = useState({ name: "Normal Menu", chatBarText: "Tap to open", areas: {} })

    useEffect(() => {
        if (data) {
            setRichmenuObject(data.description)
            setSelectedLayout(data.layout)
            setSelectedImage(data.image_path)
            setPreviewImage(`${AppConfig.endpoint}/member/backend/rich_menu/image/${data.image_path}`)
        }
    }, [])

    // Process richmenu description 
    function processRichMenuObject(layout) {
        let description = richmenuObject.areas

        // Size 2500x1686, 2500x843, 1200x810, 1200x405, 800x540, 800x270
        let areas = []
        let width = 2500;
        let height = 1686;
        if (layout.type === 'c') height = 843;
        let nrow = layout.template.length;
        for (var r = 0; r < nrow; r++) {
            let ncol = layout.template[r];

            for (var c = 0; c < layout.template[r]; c++) {
                let itemName = (r + 1) + '-' + (c + 1);
                let area = {
                    "bounds": {
                        "x": c * Math.floor(width / ncol),
                        "y": r * Math.floor(height / nrow),
                        "width": Math.floor(width / ncol),
                        "height": Math.floor(height / nrow),
                    }
                };
                if (description[itemName + '-type'] === 'uri') {
                    area["action"] = {
                        "type": "uri",
                        "label": "",
                        "uri": description[itemName] || "",
                    }
                }
                else {
                    area["action"] = {
                        "type": "message",
                        "label": "",
                        "text": description[itemName] || "",
                    }
                }

                areas.push(area)
            }
        }

        let newRichmenuObject = {
            ...richmenuObject,
            ...{
                "selected": true,
                "size": {
                    "width": width,
                    "height": height
                },
                "areas": areas,
            }
        }

        setRichmenuObject(newRichmenuObject)
    }

    // Handle rich menu description change
    function handleDescriptionChange(e) {
        let updateState = richmenuObject.areas;

        try {
            if (e.target.type === "number") {
                if (e.target.name.startsWith("[")) {
                    eval(`updateState${e.target.name} = Number.parseFloat(e.target.value)`)
                }
                else {
                    eval(`updateState.${e.target.name} = Number.parseFloat(e.target.value)`)
                }
            }
            else {
                if (e.target.name.startsWith("[")) {
                    eval(`updateState${e.target.name} = e.target.value`)
                }
                else {
                    eval(`updateState.${e.target.name} = e.target.value`)
                }
            }
        }
        catch (ex) {
            console.error(ex)
            updateState[e.target.name] = e.target.value
        }

        setRichmenuObject({ ...richmenuObject, areas: updateState })
        // processRichMenuObject(selectedLayout);
    }

    // Handle image file select
    function onImageChange(event) {
        console.log(event.target.files[0])
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = async (e) => {
                // Upload Image 
                var formData = new FormData();
                formData.append("image", event.target.files[0], 'upload.png');

                console.log(event.target.files)

                let result = await axios.post(`${AppConfig.endpoint}/member/backend/rich_menu/image`, { image: reader.result },
                    {
                        headers: {
                            "x-access-token": line_access_token,
                            "x-api-key": AppConfig.api_key
                        },
                    })

                setSelectedImage(result.data.image_path)
                setPreviewImage(`${AppConfig.endpoint}/member/backend/rich_menu/image/${result.data.image_path}`)
            };

            reader.readAsDataURL(event.target.files[0]);
        }
    }

    let layoutComs = [];
    for (let lidx in layouts) {
        const layout = layouts[lidx];
        layoutComs.push(
            <RichMenuTemplate key={lidx}
                layout={layout}
                onClick={() => { setSelectedLayout(layout); processRichMenuObject(layout) }}
                active={selectedLayout == lidx}
                src={previewImage || selectedImage} />
        )
    }

    if (!richmenuObject) return null

    return <div className="columns">
        <div className="column">
            <div className="richmenu-templates">
                <label className="label is-small">Layouts</label>
                {layoutComs}
                <div className="is-clearfix"></div>
            </div>

            <div className="has-text-centered" style={{ marginTop: 10 }}>
                <div className="file-button-wrapper">
                    <button className="button is-small">
                        <span class="icon"><i class="fas fa-images"></i></span>
                        <span>Change Image</span>
                    </button>
                    <input type="file" onChange={onImageChange} />
                </div>
            </div>
        </div>
        <div className="column">
            <div className="field">
                <label className="label is-small">Name</label>
                <div className="control">
                    <input className="input is-small" type="text" value={richmenuObject.name} onChange={(e) => setRichmenuObject({ ...richmenuObject, name: e.target.value })} />
                </div>
            </div>

            <div className="field ">
                <label className="label is-small">Bar Text</label>
                <div className="control">
                    <input className="input is-small" type="text" value={richmenuObject.chatBarText} onChange={(e) => setRichmenuObject({ ...richmenuObject, chatBarText: e.target.value })} />
                </div>
            </div>

            <label className="label is-small">Description</label>
            <RichMenuDescription
                description={richmenuObject.areas}
                layout={selectedLayout}
                onChange={handleDescriptionChange} />

            <div className="has-text-centered" style={{ marginTop: 10 }}>
                {onSave && <button className="button is-success" onClick={() => onSave(name, richmenuObject, selectedLayout, selectedImage)}>Update Richmenu</button>}
            </div>

        </div>
    </div>
}